import { get, size } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioCreators } from "modules/portfolio-root/model"
import { classificationsQuery, generateClassificationQuery } from "helpers/classification"
import { generateIntradayBatchUrl } from "helpers/intraday"
import { getSelectedModelId, getIsExpanded, getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { getAccount, getAccountId, getAvailableRollups, getHasData, getIsRefreshing, getLastRefresh, getPortfolioId, getSegment, getSelectedScreen, getPortfolioIntradayEnabled, getMenuItems } from "./selectors"
import { getChips } from "./selectors/chips"
import { getDate } from "./selectors/dates"
import { getChipSecuritiesIds, getClassificationsTiers, getEditingFilter, getFilterOns, getAddedFilters } from "./selectors/filters"
import withUrlParams from "hocs/withUrlParams"
import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: getAccount(state, props),
    accountId: getAccountId(state, props),
    classificationsTiers: getClassificationsTiers(state, props),
    date: getDate(),
    modelId: getSelectedModelId(state, props),
    portfolio: get(state, "global.selected.portfolio"),
    portfolioId: getPortfolioId(state, props),
    securitiesIds: getChipSecuritiesIds(state, props),
    isExpanded: getIsExpanded(state, props),
    intradayEnabled: getPortfolioIntradayEnabled(state, props),
  }),
  required: ["account", "modelId", "portfolio", "portfolioId"],
  data: [{
    resource: "classifications",
    as: null,
    url: () => ({
      id: "classifications",
      query: classificationsQuery,
    }),
  }, {
    resource: "classificationsValues",
    as: null,
    url: ({ classificationsTiers, date }) => {
      if (size(classificationsTiers) === 0 || !date) {
        return null
      }

      // We don't know the depth of each classification, generate each classification sub query according to the tier depth
      return {
        id: `classificationsValues-${date}${JSON.stringify(classificationsTiers)}`,
        query: `query {
          ${generateClassificationQuery(classificationsTiers)}
        }`,
      }
    },
  }, {
    intradayChannel: ({ accountId, portfolioId }) => `${accountId}_${portfolioId}`,
    resource: "portfolioFilters",
    as: null,
    url: ({ account, modelId, portfolioId, date, isExpanded }) => `/api/${account}/m/${modelId}/r/portfolio/${portfolioId}/filters?startDate=${date}&endDate=${date}&intraday=true&expand=${isExpanded}`,
  }, {
    resource: "portfolioSecuritiesDescriptors",
    url: ({ account, modelId, securitiesIds, date }) => {
      if (size(securitiesIds) === 0) {
        return null
      }

      return {
        url: `/api/${account}/m/${modelId}/securities/descriptors?date=${date}`,
        id: `securitiesDescriptors-${account}${modelId}${date}${JSON.stringify(securitiesIds)}`,
        payload: { ids: securitiesIds },
      }
    },
  }, {
    intradayChannel: ({ accountId, portfolioId }) => `${accountId}_${portfolioId}`,
    resource: "intradayLastBatch",
    as: null,
    url: ({ account, portfolioId, date, intradayEnabled }) => intradayEnabled ? generateIntradayBatchUrl(account, portfolioId, date) : null,
  }],
  actions: {
    ...Creators,
    setExpansionMode: PortfolioCreators.setExpansionMode,
  },
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.intraday"),
    hasData: getHasData(state, props),
    isRefreshing: getIsRefreshing(state, props),
    availableRollups: getAvailableRollups(state, props),
    chips: getChips(state, props),
    editingFilter: getEditingFilter(state, props),
    filterOns: getFilterOns(state, props),
    lastRefresh: getLastRefresh(state, props),
    selectedScreen: getSelectedScreen(state, props),
    segment: getSegment(state, props),
    intradayEnabled: getPortfolioIntradayEnabled(state, props),
    menuItems: getMenuItems(state, props),
    currency: getCurrency(state, props),
    addedFilters: getAddedFilters(state, props),
  }),
}))
